(function () {
  function formatMoney(cents) {
    var currency = window.themeVendor && window.themeVendor.themeCurrency;
    var moneyFormat = window.theme && window.theme.moneyFormat;
    var formatted;

    if (currency && moneyFormat) {
      formatted = currency.formatMoney(cents, moneyFormat);
      if (window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
        formatted += ' ' + window.theme.currencyCode;
      }
      return formatted;
    }

    return (cents / 100).toFixed(2);
  }

  function parseCents(value) {
    var amount = parseInt(value, 10);
    return isNaN(amount) ? 0 : amount;
  }

  function init(wrapper) {
    if (wrapper.dataset.oelSaleBadgeReady === 'true') return;
    wrapper.dataset.oelSaleBadgeReady = 'true';

    var section = wrapper.closest('[data-section-type="product"]') || document;
    var priceEl = wrapper.querySelector('[data-product-price]');
    var compareWrap = wrapper.querySelector('[data-compare-text]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var price = parseCents(wrapper.getAttribute('data-oel-product-price'));
    var compare = parseCents(wrapper.getAttribute('data-oel-product-compare'));

    function update() {
      if (priceEl) {
        priceEl.innerHTML = formatMoney(price);
      }

      if (!compareWrap || !compareEl) return;

      if (compare > 0 && compare < price) {
        compareEl.innerHTML = formatMoney(compare);
        compareWrap.classList.remove('hide');
      } else {
        compareWrap.classList.add('hide');
      }
    }

    update();
    section.addEventListener('theme:variant:change', update);
  }

  function initAll() {
    document.querySelectorAll('.product-oel__price [data-price-wrapper]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
